import ApiRequest from '../../../Apis/request'

export default class ApiCopros {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async updateCopro(id, payload) {
    try {
      const res = await this.apiRequest.put(`/copros/${id}`, { ...payload })
      return res
    } catch (error) {
      return error.response
    }
  }
  async getCopros(filter) {
    try {
      const res = await this.apiRequest.get(`/copros`, {
        filter: JSON.stringify(filter),
      })
      return res
    } catch (error) {
      return error.response
    }
  }
}
